<template>
  <div class="temp-body">
    <div class="row legenda col-md-12 col-6">
      <div class="col-md-2">V/P min</div>
      <div class="col-md-2">V/P max</div>
      <div class="col-md-2">Standard</div>
      <div class="col-md-2">Express</div>
    </div>

    <div class="row scaglioni col-md-12 col-6">
      <div class="col-md-2">
        <span v-if="!isEditing">{{ scaglioni.min_weight_volume_ratio }}</span>
        <input type="number" v-model="min" v-if="isEditing" />
      </div>
      <div class="col-md-2">
        <span v-if="!isEditing">{{ scaglioni.max_weight_volume_ratio }}</span>
        <input type="number" v-model="max" v-if="isEditing" />
      </div>
      <div class="col-md-2">
        <span v-if="!isEditing"> {{ scaglioni.standard_price }} €</span>
        <input type="number" v-model="standard" v-if="isEditing" /><span
          v-if="isEditing"
          >€</span
        >
      </div>
      <div class="col-md-2">
        <span v-if="!isEditing"> {{ scaglioni.express_price }} €</span>
        <input @keyup.enter="update" type="number" v-model="express" v-if="isEditing" /><span
          v-if="isEditing"
          >€</span
        >
      </div>
      <div class="col-md-2 my-icon">
        <i v-if="!isEditing" @click="edit" class="fas fa-pen orange"></i>
        <i v-if="isEditing" @click="update" class="fas fa-check green"></i>
        <i
          @click="elimina_rank = scaglioni.id"
          class="fas fa-trash red ml-5"
        ></i>
        <div class="conferma" v-if="elimina_rank != null">
          <div class="modal-white container">
            <div class="row">
              <h1 class="col-md-12">
                Sei sicuro di voler cancellare questo scaglione?
              </h1>
              <div class="col-md-3">
                <button class="belt-btn" @click="elimina_rank = null">
                  Annulla
                </button>
              </div>
              <div class="col-md-9">
                <button class="belt-btn" @click="deleteRank()">
                  Prosegui con la cancellazione
                </button>
              </div>
            </div>
          </div>
        </div>

        <b-message
          class="messaggio-successo"
          type="is-success"
          v-model="successEdit"
        >
          Modifiche salvate
        </b-message>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "scaglioni",
  props: ["scaglioni"],
  data() {
    return {
      elimina_rank: null,
      min: null,
      max: null,
      standard: null,
      express: null,
      isEditing: false,
      successEdit: false,
    };
  },
  mounted() {
    this.min = this.scaglioni.min_weight_volume_ratio;
    this.max = this.scaglioni.max_weight_volume_ratio;
    this.standard = this.scaglioni.standard_price;
    this.express = this.scaglioni.express_price;
  },
  methods: {
    refresh: function () {
      this.$emit("refresh", true);
    },

    deleteRank: function () {
      axios({
        method: "get",
        url: window.location.origin + "/admin/shipping",
        params: {
          action: "delete-ranks",
          id: this.elimina_rank,
        },
      }).then((res) => {
        //console.log(res.data);
        this.successEdit = true;
        this.elimina_rank = null;
        this.refresh();
        setTimeout(() => {
          this.successEdit = false;
        }, 3000);
      });
    },
    edit: function () {
      this.isEditing = !this.isEditing;
    },
    update: function () {
      this.isEditing = !this.isEditing;
      axios({
        method: "get",
        url: window.location.origin + "/admin/shipping",
        params: {
          action: "update-ranks",
          id: this.scaglioni.id,
          min: parseFloat(this.min),
          max: parseFloat(this.max),
          standard: parseFloat(this.standard),
          express: parseFloat(this.express),
        },
      }).then((res) => {
        //console.log(res.data);
        this.successEdit = true;
        this.refresh();

        setTimeout(() => {
          this.successEdit = false;
        }, 3000);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.row.scaglioni {
  padding: 0;
  position: relative;
  input {
    width: 80%;
  }
  .messaggio-successo {
    position: absolute;
    display: inline-block;
    right: -50%;
  }
}
.fas {
  font-size: 20px;
}

.temp-body {
  display: flex;
  .legenda,
  .scaglioni {
    flex-direction: column;
  }
}

.my-icon {
  position: absolute;
  top: 50%;
  left: 85%;
}

@media (min-width: 768px) {
  .temp-body {
    display: block;
    .legenda,
    .scaglioni {
      flex-direction: row;
    }
  }

  .legenda {
    display: none;
  }
  .my-icon {
    // display: none;
    position: relative;
    top: unset;
    left: unset;
  }
}
</style>
